import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import PasswordStrengthMeter from './PasswordStrengthMeter'
import Enzoic from '@enzoic/enzoic-react-password-strength'
import '../../styles/profile.css'
import profileStyles from './profileStyles'

import Cropper from 'react-easy-crop'

import { withStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import { Snackbar, Avatar, Dialog } from '@material-ui/core'

import DialogContent from '@material-ui/core/DialogContent'

import InformationIcon from 'calcite-ui-icons-react/InformationIcon'

import { getTimezones, getTimezoneByID } from '../../actions/timezones'

import { readFile, createImage, createImageBase64, getCroppedImg } from '../utils/AvatarFunctions'

import {
  Box,
  SwxTheme,
  Tabs,
  Tab,
  TabList,
  TabPanels,
  TabPanel,
  Textfield,
  Typography,
  Button,
  Dropdown
} from 'swx-atomic-component-lib'

import {
  checkLoggedin,
  updateUserProfile,
  updateUserAvatar,
  changeFile,
  changeCrop,
  loadImage,
  updateUserPassword,
  deleteAvatar
} from '../../actions/users'

import { hideNotification } from '../../actions/notifications'

import queryString from 'query-string'
import i18n from '../../i18n'

const { x3, x4 } = SwxTheme.sizing

const styles = theme => ({
  avatar: {
    height: 64,
    width: 64,
    backgroundColor: SwxTheme.palette.g200,
    marginBottom: 16,
    cursor: 'pointer',
    boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2)'
  },
  dialogPaper: {
    minWidth: 386,
    '@media screen and (max-height: 535px) and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
      minHeight: 400 // only for IE 11, fix the height when screen is small to avoid double scrollbar
    }
  },
  hr: {
    width: '100%',
    borderColor: SwxTheme.palette.g300,
    backgroundColor: SwxTheme.palette.g300,
    borderTop: `1px solid ${SwxTheme.palette.g300}`
  },
  profileTab: {
    maxHeight: 'none',
    paddingBottom: '170px'
  },
  passwordTab: {
    maxHeight: 'none',
    paddingBottom: '170px'
  },
  customFileUpload: {
    marginTop: 'unset',
    border: `1px solid ${SwxTheme.palette['secondary-dark']}`,
    display: 'inline-block',
    padding: '6px 12px',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'center',
    fontSize: '13px !important'
  },
  inputFileUpload: {
    display: 'none'
  },
  infoIcon: {
    verticalAlign: 'middle',
    marginRight: 6
  }
})
// eslint-disable-next-line prefer-regex-literals
const INVALID_CHAR_REG = new RegExp('[=\\+\\-\\@]')

class Profile extends Component {
  constructor (props) {
    super(props)
    this.user = this.props.self.user || {}
    this.state = {
      firstName: this.user.first_name,
      firstNameError: false,
      firstNameErrorMessage: '',
      lastName: this.user.last_name,
      lastNameError: false,
      lastNameErrorMessage: '',
      jobTitle: this.user.job_title,
      jobTitleError: false,
      contactPhoneNo: this.user.mobile_number,
      contactPhoneNoError: false,
      contactPhoneNoErrorMessage: '',
      email: this.user.email,
      isDialogOpen: false,
      noImageYet: false,
      timezones: [],
      timezoneId: this.user.timezone_id,
      activeIndex: 0,
      onloadActiveIndex: 0,
      currentPassword: '',
      currentPasswordError: false,
      currentPasswordErrorMessage: '',
      newPassword: '',
      newPasswordError: false,
      newPasswordErrorMessage: '',
      confirmPassword: '',
      confirmPasswordError: false,
      confirmPasswordErrorMessage: '',
      saveButtonDisabled: true,
      showPassword: false,
      currentPasswordReadOnly: true,
      zoom: 1,
      aspect: 1,
      crop: { x: 0, y: 0 },
      imageSrc: null,
      croppedAreaPx: null,
      imageFromURL: true,
      avatarError: null,
      isDisableUpdateButton: false,
      passwordScore: -1,
      zxcvbnResult: null,
      isNewWindow: false,
      isValidPassword: false
    }
    this.handleUpdateSelectedTimezoneID = this.handleUpdateSelectedTimezoneID.bind(this)
    this.checkAllFieldsState = this.checkAllFieldsState.bind(this)
    this.handleConfirmPasswordChange = this.handleConfirmPasswordChange.bind(this)
    this.handleCancelButtonClick = this.handleCancelButtonClick.bind(this)
  }

  componentDidMount () {
    if (!_.isEmpty(window.name)) {
      this.setState({ isNewWindow: true })
    }

    const params = queryString.parse(this.props.location.search)

    if (params.tab === 'change_password') {
      this.setState({ onloadActiveIndex: 1 })
    }

    this.props.getTimezones().then((timezones) => {
      const timezonesList = timezones.value.data.map(tz => {
        return { label: `${tz.name}`, id: tz.id, value: tz.id }
      })
      this.setState({ timezones: timezonesList })
    })
  }

  onChange = (e) => {
    const state = this.state
    if (!_.isEmpty(e.target.value)) {
      state[e.target.name] = e.target.value
      this.setState(state)
    }
  }

  handleOnChangeAvatarClick = (e) => {
    if (this.state.noImageYet === false) {
      this.setState({ imageSrc: `${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users/me/avatar?${new Date().getTime()}` })
    } else {
      this.setState({
        imageSrc: null,
        imageFromURL: false
      })
    }
    this.setState({ isDialogOpen: true })
  }

  handleOnClearImageClick = () => {
    this.props.deleteAvatar().then(() => {
      this.setState({ noImageYet: true })
    })
      .catch(() => { this.setState({ noImageYet: true }) })
  }

  handleOnCloseDialogClick = (e) => {
    this.props.self.image = null
    this.setState({
      imageSrc: `${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users/me/avatar?${new Date().getTime()}`,
      isDialogOpen: false,
      zoom: 1,
      avatarError: null,
      isDisableUpdateButton: false
    })
  }

  handleOnFileChange = async e => {
    try {
      if (e.target.files && e.target.files.length > 0) {
        this.setState({ avatarError: null })
        const imageDataUrl = await readFile(e.target.files[0])
        this.setState({
          imageSrc: imageDataUrl,
          crop: { x: 0, y: 0 },
          zoom: 1,
          imageFromURL: false,
          isDisableUpdateButton: false
        })
      }
    } catch (err) {
      this.setState({
        avatarError: i18n.profile.edit.dialog.avatarSizeError,
        isDisableUpdateButton: true
      })
    }
  }

  handleOnCropChange = crop => {
    this.setState({ crop })
  }

  handleOnCropComplete = (croppedArea, croppedAreaPixels) => {
    this.setState({ croppedAreaPx: croppedAreaPixels })
  }

  onZoomChange = zoom => {
    this.setState({ zoom })
  }

  handleSliderChange = event => {
    this.setState({ zoom: event.target.value })
  }

  handleSnackbarClose = (e) => {
    this.props.hideNotification()
  }

  handleOnUploadClick = async (e) => {
    if (!this.state.imageSrc) return

    let baseImg = ''

    if (this.state.imageFromURL) {
      let imgTag = ''
      imgTag = await createImage(this.state.imageSrc)
      baseImg = await createImageBase64(imgTag)
    } else {
      baseImg = this.state.imageSrc
    }

    const croppedImg = await getCroppedImg(baseImg, this.state.croppedAreaPx)

    this.props.updateUserAvatar(croppedImg).then(() => {
      if (this.state.noImageYet) {
        this.setState({ noImageYet: false })
      }
      this.setState({
        isDialogOpen: false,
        imageSrc: `${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users/me/avatar?${new Date().getTime()}`,
        imageFromURL: true,
        zoom: 1
      })
    })
  }

  handleSaveProfileButtonClick = () => {
    if (this.state.activeIndex === 0) {
      // save user profile
      const profileData = {
        first_name: this.state.firstName,
        last_name: this.state.lastName,
        mobile_number: this.state.contactPhoneNo,
        timezone_id: this.state.timezoneId,
        job_title: this.state.jobTitle
      }
      this.props.updateUserProfile(this.user.id, profileData)
    } else if (this.state.activeIndex === 1) {
      const updatePasswordData = {
        oldPassword: this.state.currentPassword,
        newPassword: this.state.newPassword,
        confirmPassword: this.state.confirmPassword
      }

      this.props.updateUserPassword(updatePasswordData)
        .then(() => {
          this.reset()
          this.setState({ success: true })
          setTimeout(() => this.setState({ success: false }), 3000)
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            window.location.href = '/login'
            return
          } else if (err.response && err.response.data.msg === 'wrong password') {
            this.setState({
              currentPasswordError: true,
              currentPasswordErrorMessage: 'The password entered is invalid'
            })
            this.setState({
              newPasswordError: false,
              newPasswordErrorMessage: ''
            })
            this.checkAllFieldsState({ currentPasswordError: true })
          } else if (err.response && err.response.data.msg === 'new password same as current password') {
            this.setState({ newPasswordError: true })
            this.setState({ newPasswordErrorMessage: 'New password cannot be the same as the current password' })
            this.checkAllFieldsState({ newPasswordError: true })
          }

          this.setState({ error: err.response })
        })
        .finally(() => this.setState({ disableBtn: false }))
    }
    this.setState({ saveButtonDisabled: true })
  }

  handleCancelButtonClick () {
    if (!this.state.isNewWindow) {
      window.name = ''
      window.history.back()
    } else {
      window.close()
    }
  }

  handleUpdateSelectedTimezoneID = (value) => {
    let timezoneId
    (value && value.id ? timezoneId = value.id : timezoneId = 0)
    this.setState({ timezoneId })
    this.checkAllFieldsState({ timezoneChanged: true })
  }

  handleFirstNameChange = (value) => {
    if (value.trim() === '') {
      this.setState({ firstNameError: true })
      this.setState({ firstNameErrorMessage: i18n.signUpPage.error.firstNameRequired })
    } else if (INVALID_CHAR_REG.test(value)) {
      this.setState({ firstNameError: true })
      this.setState({ firstNameErrorMessage: i18n.signUpPage.error.firstNameInvalidChar })
    } else {
      this.setState({ firstName: value })
      this.setState({ firstNameError: false })
      this.setState({ firstNameErrorMessage: '' })
      this.checkAllFieldsState({ firstNameError: false })
    }
  }

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }))
  }

  handleLastNameChange = (value) => {
    if (value.trim() === '') {
      this.setState({ lastNameError: true })
      this.setState({ lastNameErrorMessage: i18n.signUpPage.error.lastNameRequired })
      this.checkAllFieldsState({ lastNameError: true })
    } else if (INVALID_CHAR_REG.test(value)) {
      this.setState({ lastNameError: true })
      this.setState({ lastNameErrorMessage: i18n.signUpPage.error.lastNameInvalidChar })
    } else {
      this.setState({ lastName: value })
      this.setState({ lastNameError: false })
      this.setState({ lastNameErrorMessage: '' })
      this.checkAllFieldsState({ lastNameError: false })
    }
  }

  handleJobTitleChange = (value) => {
    this.setState({ jobTitle: value })
    this.checkAllFieldsState({ jobTitleError: false })
  }

  handlePhoneNoChange = (value) => {
    if (value.trim() === '') {
      this.setState({ contactPhoneNoError: false })
      this.setState({ contactPhoneNoErrorMessage: '' })
      this.checkAllFieldsState({ contactPhoneNoError: false })
    } else {
      // eslint-disable-next-line prefer-regex-literals
      const reg = new RegExp(/^\d+$/)
      if (reg.test(value)) {
        this.setState({ contactPhoneNo: value })
        this.setState({ contactPhoneNoError: false })
        this.setState({ contactPhoneNoErrorMessage: '' })
        this.checkAllFieldsState({ contactPhoneNoError: false })
      } else {
        this.setState({ contactPhoneNoError: true })
        this.setState({ contactPhoneNoErrorMessage: 'Phone number only accepts digits' })
        this.checkAllFieldsState({ contactPhoneNoError: true })
      }
    }
  }

  handleActivateTextfield = () => {
    this.setState({ currentPasswordReadOnly: false })
  }

  handleCurrentPasswordChange = (value) => {
    if (value.trim() === '') {
      this.checkAllFieldsState({ currentPasswordError: true })
    } else {
      this.setState({ currentPassword: value })
      this.setState({ currentPasswordError: false })
      this.setState({ currentPasswordErrorMessage: '' })
      this.checkAllFieldsState({ currentPasswordError: false })
    }
  }

  handleNewPasswordChange = (res) => {
    this.setState({
      passwordScore: res.score,
      zxcvbnResult: res.zxcvbnResult,
      isValidPassword: res.isValid
    })
    const value = res.password

    if (value.trim() === '') {
      this.setState({ newPassword: '' })
      this.checkAllFieldsState({ newPasswordError: true })
    } else {
      this.setState({ newPassword: value })
      this.setState({ newPasswordError: false })
      this.setState({ newPasswordErrorMessage: '' })
      this.checkAllFieldsState({ newPasswordError: false })
    }
  }

  handleConfirmPasswordChange = () => {
    const value = document.getElementById('confirmPassword').value
    const newPassvalue = document.getElementById('newPassword').value
    if (value.trim() === '' && newPassvalue.trim() !== '') {
      this.checkAllFieldsState({ confirmPasswordError: true })
    } else {
      this.setState({
        confirmPassword: value,
        confirmPasswordError: false,
        confirmPasswordErrorMessage: ''
      })
      this.checkAllFieldsState({ confirmPasswordError: false })
    }
  }

  checkAllFieldsState = (val) => {
    if (this.state.activeIndex === 0) {
      const firstNameErr = (typeof val.firstNameError !== 'undefined') ? val.firstNameError : this.state.firstNameError
      const lastNameErr = (typeof val.lastNameError !== 'undefined') ? val.lastNameError : this.state.lastNameError
      const contactPhoneNoErr = (typeof val.contactPhoneNoError !== 'undefined') ? val.contactPhoneNoError : this.state.contactPhoneNoError
      const timezoneChanged = (typeof val.timezoneChanged !== 'undefined') ? val.timezoneChanged : true

      if (firstNameErr || lastNameErr || contactPhoneNoErr || !timezoneChanged) {
        this.setState({ saveButtonDisabled: true })
      } else {
        this.setState({ saveButtonDisabled: false })
      }
    } else if (this.state.activeIndex === 1) {
      this.checkPasswordRules()
    }
  }

  checkPasswordRules = () => {
    const currentPassVal = document.getElementById('currentPassword').value
    const newPassVal = document.getElementById('newPassword').value
    const confirmPassVal = document.getElementById('confirmPassword').value

    if (_.isEmpty(_.trim(currentPassVal)) || _.isEmpty(_.trim(newPassVal)) || _.isEmpty(_.trim(confirmPassVal))) {
      this.setState({ saveButtonDisabled: true })
    } else {
      if (_.isEqual(newPassVal, confirmPassVal)) {
        if (this.state.isValidPassword) {
          this.setState({
            saveButtonDisabled: false,
            confirmPasswordError: false,
            confirmPasswordErrorMessage: ''
          })
        } else {
          this.setState({ saveButtonDisabled: true })
        }
      } else {
        this.setState({
          confirmPasswordError: true,
          confirmPasswordErrorMessage: 'The new password again must match the new password',
          saveButtonDisabled: true,
          newPasswordError: false,
          newPasswordErrorMessage: '',
          currentPasswordError: false,
          currentPasswordErrorMessage: ''
        })
      }
    }
  }

  resetAllErrors = () => {
    this.setState({
      firstNameError: false,
      firstNameErrorMessage: '',
      lastNameError: false,
      lastNameErrorMessage: '',
      contactPhoneNoError: false,
      contactPhoneNoErrorMessage: '',
      currentPasswordError: false,
      currentPasswordErrorMessage: '',
      newPasswordError: false,
      newPasswordErrorMessage: '',
      confirmPasswordError: false,
      confirmPasswordErrorMessage: ''
    })
  }

  render () {
    const { classes } = this.props
    return (
      <>
        <Grid container spacing={8} justify='center'>
          <Grid item xs={12} sm={8} md={8}>
            <Box customStyle='margin-bottom: 24px; margin-top: 12px;'>
              <Typography size={x4} customStyle={`color: ${SwxTheme.palette.primary}; margin-bottom:16px;`}>{i18n.profile.header}</Typography>
              <Typography customStyle='font-size:14px;'>{i18n.profile.desc}</Typography>
            </Box>
            <Box>
              <Tabs
                activeIndex={this.state.onloadActiveIndex}
                tabProps={{
                  customStyle: 'background-color: transparent; width: 200px;'
                }}
              >
                {state => {
                  if (state.activeIndex !== this.state.activeIndex) {
                    this.setState({ saveButtonDisabled: true })
                    this.setState({ activeIndex: state.activeIndex })
                    this.setState({ currentPasswordReadOnly: true })
                    this.resetAllErrors()
                  }

                  return (
                    <>
                      <TabList role='tablist' defaultActiveTab={0}>
                        <Tab tabindex='1' role='tab'>
                          {i18n.profile.edit.tab}
                        </Tab>
                        <Tab tabindex='2' role='tab'>
                          {i18n.profile.password.tab}
                        </Tab>
                      </TabList>
                      <TabPanels>
                        <TabPanel className={classes.profileTab}>
                          <Box w='100%' pt={x3} customStyle={`background-color: ${SwxTheme.palette.g100} `}>
                            <Box customStyle='padding-left:40px;'>
                              <Typography variant='medium' customStyle='font-size:14px; margin-bottom:8px;'>{i18n.profile.edit.image.title}</Typography>
                              <Typography variant='normal' customStyle='font-size:12px; margin-bottom:16px;'>{i18n.profile.edit.image.instruction}</Typography>
                              {
                                this.state.noImageYet === false && (
                                  <>
                                    <Avatar
                                      alt='Avatar Image'
                                      src={`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users/me/avatar?${new Date().getTime()}`}
                                      onError={() => this.setState({ noImageYet: true })}
                                      className={classes.avatar}
                                      // customStyle={profileStyles.avatar}
                                      onClick={this.handleOnChangeAvatarClick}
                                    />
                                    <Typography customStyle={profileStyles.clearImage} onClick={this.handleOnClearImageClick}>Clear image</Typography>
                                  </>
                                )
                              }
                              {
                                this.state.noImageYet === true && (
                                  <Avatar
                                    alt='Avatar Image'
                                    className={classes.avatar}
                                    style={{
                                      backgroundColor: SwxTheme.palette.primary,
                                      color: SwxTheme.palette.white,
                                      fontSize: '21px',
                                      textShadow: '0px 1px 1px rgba(0,0,0,0.4)',
                                      fontWeight: 400
                                    }}
                                    onClick={this.handleOnChangeAvatarClick}
                                  >
                                    {
                                      `${this.user.first_name ? this.user.first_name.charAt(0) : this.user.email.charAt(0)}`
                                    }

                                  </Avatar>
                                )
                              }
                              <Dialog
                                open={this.state.isDialogOpen}
                                onClose={this.handleOnCloseDialogClick}
                                // classes={classes.dialogBox}
                                PaperProps={{ classes: { root: classes.dialogPaper } }}
                                width='424px'
                                aria-labelledby='alert-dialog-title'
                                aria-describedby='alert-dialog-description'
                              >
                                {/* <DialogTitle id='alert-dialog-title' className={classes.dialogTitle}>{'Profile image'}</DialogTitle> */}
                                <Typography customStyle={profileStyles.dialogTitle}>{i18n.profile.edit.image.title}</Typography>
                                <DialogContent>
                                  <Box customStyle={profileStyles.dialogBody}>
                                    <Box customStyle={profileStyles.cropperBox}>
                                      {!this.state.imageSrc && <Box customStyle={profileStyles.cropperRound} />}
                                      {this.state.imageSrc &&
                                        <Cropper
                                          image={this.state.imageSrc}
                                          crop={this.state.crop}
                                          zoom={this.state.zoom}
                                          aspect={this.state.aspect}
                                          cropShape='round'
                                          showGrid={false}
                                          onCropChange={this.handleOnCropChange}
                                          onCropComplete={this.handleOnCropComplete}
                                        />}
                                    </Box>
                                    <Box customStyle={profileStyles.sliderContainer}>
                                      <input
                                        type='range'
                                        min='1'
                                        max='5'
                                        step='0.1'
                                        value={this.state.zoom}
                                        onChange={this.handleSliderChange}
                                        className='slider'
                                        id='myRange'
                                      />
                                    </Box>
                                    <label htmlFor='avatar' className={classes.customFileUpload}>
                                      {i18n.profile.edit.dialog.browseButton}
                                    </label>
                                    <input type='file' name='avatar' id='avatar' accept='.jpg, .jpeg, .png' onChange={this.handleOnFileChange} className={classes.inputFileUpload} />
                                  </Box>
                                </DialogContent>
                                {/* <DialogActions> */}
                                <Box customStyle={profileStyles.dialogFooter}>
                                  <Box customStyle={profileStyles.dialogFooterContainer}>
                                    <Box customStyle={profileStyles.dialogAllowedFiles}>
                                      <InformationIcon filled size={16} className={classes.infoIcon} /> <Typography customStyle='font-size: 13px;'>{i18n.profile.edit.dialog.info}</Typography>
                                    </Box>
                                    <Box customStyle={profileStyles.dialogActionButtons}>
                                      <Button ghost onClick={this.handleOnCloseDialogClick} customStyle={profileStyles.actionButton}>{i18n.common.button.cancel}</Button>
                                      {
                                        this.props.self && this.props.self.isProcessing
                                          ? <Button color='secondary' disabled customStyle={profileStyles.actionButton}>{i18n.common.button.update}</Button>
                                          : <Button color='secondary' disabled={this.state.isDisableUpdateButton} onClick={this.handleOnUploadClick} customStyle={profileStyles.actionButton}>{i18n.common.button.update}</Button>
                                      }
                                    </Box>
                                  </Box>
                                  {
                                    this.state.avatarError && (<Typography customStyle={profileStyles.avatarError}>{this.state.avatarError}</Typography>)
                                  }
                                </Box>
                                {/* </DialogActions> */}
                              </Dialog>

                            </Box>
                            <hr className={classes.hr} />
                            <Box customStyle='padding-left:40px;margin-bottom:24px;padding-right:40px;'>
                              <Typography variant='medium' customStyle='font-size:14px; margin-top:24px; margin-bottom:8px;'>{i18n.profile.edit.firstName}</Typography>
                              <Textfield
                                defaultValue={this.user.first_name}
                                message={this.state.firstNameErrorMessage}
                                customStyle={profileStyles.commonTextfield}
                                onChange={this.handleFirstNameChange}
                                error={this.state.firstNameError}
                                validationProps={{ customStyle: 'margin-top: 0px;' }}
                                maxLength='100'
                                color='primary'
                              />

                              <Typography variant='medium' customStyle='font-size:14px; margin-top:24px; margin-bottom:8px;'>{i18n.profile.edit.lastName}</Typography>
                              <Textfield
                                defaultValue={this.user.last_name}
                                message={this.state.lastNameErrorMessage}
                                customStyle={profileStyles.commonTextfield}
                                onChange={this.handleLastNameChange}
                                error={this.state.lastNameError}
                                validationProps={{ customStyle: 'margin-top: 0px;' }}
                                maxLength='100'
                                color='primary'
                              />

                              <Typography variant='medium' customStyle='font-size:14px; margin-top:24px; margin-bottom:8px;'>{i18n.profile.edit.jobTitle}</Typography>
                              <Textfield
                                defaultValue={this.user.job_title}
                                message={this.state.jobTitleErrorMessage}
                                customStyle={profileStyles.commonTextfield}
                                onChange={this.handleJobTitleChange}
                                error={this.state.jobTitleError}
                                validationProps={{ customStyle: 'margin-top: 0px;' }}
                                maxLength='100'
                                color='primary'
                              />

                              <Typography variant='medium' customStyle='font-size:14px; margin-top:24px; margin-bottom:8px;'>{i18n.profile.edit.email}</Typography>
                              <Textfield
                                defaultValue={this.user.email}
                                variant='email'
                                customStyle={profileStyles.commonTextfield}
                                readOnly
                                color='primary'
                              />

                              <Typography variant='medium' customStyle='font-size:14px; margin-top:24px; margin-bottom:8px;'>{i18n.profile.edit.phone}</Typography>
                              <Textfield
                                defaultValue={this.user.mobile_number}
                                message={this.state.contactPhoneNoErrorMessage}
                                customStyle={profileStyles.commonTextfield}
                                onChange={this.handlePhoneNoChange}
                                error={this.state.contactPhoneNoError}
                                validationProps={{ customStyle: 'margin-top: 0px;' }}
                                maxLength='30'
                                color='primary'
                              />
                            </Box>
                            <hr className={classes.hr} />
                            <Box customStyle='padding-left:40px;padding-bottom:24px;'>
                              <Typography variant='medium' customStyle='font-size:14px; margin-top:24px; margin-bottom:8px;'>{i18n.profile.edit.timezone}</Typography>
                              <Box customStyle='width:35%'>
                                {
                                  this.state.timezones.length > 0 && <Dropdown
                                    combo='combo'
                                    type='autoComplete'
                                    selectedItem={(this.user.Timezone && this.user.Timezone.name) ? this.user.Timezone.name : ''}
                                    items={this.state.timezones}
                                    onChange={this.handleUpdateSelectedTimezoneID}
                                    label={i18n.profile.edit.timezonePlaceholder}
                                    scrollHeight='150px'
                                    customStyle={
                                      `
                                    border: 1px solid ${SwxTheme.palette.primary};
                                    border-radius: 3px;
                                    `
                                    }
                                    wrapperProps={{
                                      customStyle: `
                                                  background-color: ${SwxTheme.palette.white};
                                                  border-radius: 3px 0px 0px 3px;
                                                  `
                                    }}
                                    itemListProps={{
                                      customStyle: `
                                    width: 60%;

                                    `,
                                      height: 190
                                    }}
                                                                     />
                                }
                              </Box>
                            </Box>
                          </Box>
                        </TabPanel>
                        <TabPanel className={classes.passwordTab}>
                          <Box w='100%' pt={x3} customStyle={`background-color: ${SwxTheme.palette.g100}; padding-bottom:6px;`}>
                            <Box customStyle='padding-left:40px;padding-bottom:24px;'>
                              <Typography variant='medium' customStyle='font-size:14px; margin-top:24px; margin-bottom:8px;'>{i18n.profile.password.currentPassword}</Typography>
                              <Textfield
                                defaultValue=''
                                type='password'
                                message={this.state.currentPasswordErrorMessage}
                                customStyle={profileStyles.commonTextfield}
                                onChange={this.handleCurrentPasswordChange}
                                onClick={this.handleActivateTextfield}
                                onFocus={this.handleActivateTextfield}
                                error={this.state.currentPasswordError}
                                id='currentPassword'
                                autoComplete='off'
                                readOnly={this.state.currentPasswordReadOnly}
                                validationProps={{ customStyle: 'margin-top: 0px;' }}
                                color='primary'
                              />
                            </Box>
                            <hr className={classes.hr} />
                            <Box customStyle='padding-left:40px;padding-bottom:24px;'>
                              <Typography variant='medium' customStyle='font-size:14px; margin-top:24px; margin-bottom:8px;'>{i18n.profile.password.newPassword}</Typography>

                              <Enzoic
                                style={{ width: 'calc(36% - 5px)', backgroundColor: SwxTheme.palette.white, border: '0px', borderBottom: `1px ${SwxTheme.palette.primary} solid` }}
                                minLength={8}
                                minScore={3}
                                scoreWords={['compromised', 'weak', 'okay', 'good', 'strong', 'stronger']}
                                changeCallback={_.debounce(this.handleNewPasswordChange, 300)}
                                inputProps={{ autoComplete: 'off', className: 'form-control', id: 'newPassword' }}
                              />

                              <Typography variant='medium' customStyle='font-size:14px; margin-top:24px; margin-bottom:8px;'>{i18n.profile.password.confirmPassword}</Typography>
                              <Textfield
                                defaultValue=''
                                type='password'
                                message={this.state.confirmPasswordErrorMessage}
                                customStyle={profileStyles.commonTextfield}
                                onChange={_.debounce(this.handleConfirmPasswordChange, 700)}
                                onBlur={this.handleConfirmPasswordChange}
                                error={this.state.confirmPasswordError}
                                id='confirmPassword'
                                autoComplete='off'
                                validationProps={{ customStyle: 'margin-top: 0px;' }}
                                color='primary'
                              />
                              <PasswordStrengthMeter password={this.state.newPassword} score={this.state.passwordScore} zxcvbnResult={this.state.zxcvbnResult} minScore={3} />
                            </Box>
                          </Box>
                        </TabPanel>
                      </TabPanels>
                    </>
                  )
                }}

              </Tabs>
            </Box>

            <Snackbar
              className='profile-notification'
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              open={this.props.notification && this.props.notification.showNotification}
              autoHideDuration={this.props.notification && this.props.notification.autoHideDuration}
              onClose={this.handleSnackbarClose}
              ContentProps={{
                'aria-describedby': 'message-id'
              }}
              message={<span id='message-id'>{this.props.notification && this.props.notification.text}</span>}
              action={this.props.notification && this.props.notification.action}
              ClickAwayListenerProps={{
                onClickAway: this.props.notification && this.props.notification.disableClickAway
                  ? () => {}
                  : this.handleSnackbarClose
              }}
            />

            <Box customStyle='float:right;margin-top: -140px;'>
              <Button
                secondary
                value={i18n.common.button.cancel}
                customStyle={`
                  width: 130px;
                  margin-right: 16px;
                  border: none;
                `}
                onClick={this.handleCancelButtonClick}
              />
              <Button
                value={i18n.common.button.save}
                customStyle={`
                  width: 130px;
                `}
                onClick={this.handleSaveProfileButtonClick}
                disabled={this.state.saveButtonDisabled}
              />
            </Box>
          </Grid>
        </Grid>

      </>
    )
  }
}

function mapStateToProps (state) {
  return {
    self: state.self,
    notification: state.notification,
    timezones: state.timezones
  }
}

const ProfileComponent = withStyles(styles)(Profile)

export default connect(mapStateToProps, {
  getTimezones,
  getTimezoneByID,
  checkLoggedin,
  updateUserProfile,
  updateUserAvatar,
  hideNotification,
  changeFile,
  changeCrop,
  loadImage,
  updateUserPassword,
  deleteAvatar
})(ProfileComponent)
